import { makeMarkers } from './markerInfo';
type HoverPinState = {
  pinnedOverlay: any | null;
  pinnedId: string | null;
};

// 한 개 “점(d​ot)” + hover/leave/click 동작을 공통으로 붙여주는 함수
export function addDotMarker({
  map,
  kakao,
  item,
  priceData,
  markerDetail,
  setMarkerDetail,
  newMarkers,
  mapFilter,
  s,
}: {
  map: kakao.maps.Map;
  kakao: any;
  item: any;
  priceData: any;
  markerDetail: any;
  setMarkerDetail: (v: any) => void;
  newMarkers: kakao.maps.CustomOverlay[];
  mapFilter: any;
  s: HoverPinState;
}) {
  // const s = hoverPinRef.current;
  const dotId = `dot-marker-${item.marker_idx}`;

  const dot = makeMarkers(priceData, kakao, dotId, markerDetail, true);
  if (!dot) return;
  dot.setMap(map);
  newMarkers.push(dot);

  const handleClick = () => {
    // 기존 핀 제거
    if (s.pinnedOverlay && s.pinnedId !== dotId) {
      s.pinnedOverlay.setMap(null);
      s.pinnedOverlay = null;
      s.pinnedId = null;
    }
    // 새로 오버레이 생성
    const newPinnedId = `marker-${item.marker_idx}`;
    const newPinned = makeMarkers(priceData, kakao, newPinnedId, {
      iidx: item.marker_idx,
    });
    if (newPinned) {
      newPinned.setMap(map);
      s.pinnedOverlay = newPinned;
      s.pinnedId = dotId;
    }

    setMarkerDetail({
      type: item.type?.trim(),
      iidx: item.marker_idx,
      item_code: item.item_code,
      prc: item.prc ?? '',
      pnu: item.pnu,
      area: item.area,
      pyeong: item.pyeong,
      date: item.date,
      lat: item.lat,
      lng: item.lng,
      specialCondition: mapFilter?.specialItemCond,
      specialItems:
        mapFilter?.specialItemCondition?.length === 0
          ? ''
          : mapFilter?.specialItemCondition?.join(','),
    });
  };

  // DOM 이벤트 연결
  setTimeout(() => {
    const el = document.getElementById(dotId);
    if (!el) return;
    window.requestAnimationFrame(() => {
      el.removeEventListener('click', handleClick);
      el.addEventListener('click', handleClick);
    });
  }, 0);
}
